// Booking customer information pop-up (v2 Item 6). Store-driven like every other dialog so any
// ticket-click site can raise it with a single mutation instead of owning the pop-up itself.
export default {
  state: {
    visibility: false,
    ticket: {}
  },
  mutations: {
    INIT_BOOKING_DETAIL_DIALOG(state, payload) {
      state.visibility = payload.visibility
      state.ticket = payload.ticket
    },
    RESET_BOOKING_DETAIL_DIALOG(state) {
      state.visibility = false
      state.ticket = {}
    }
  }
}
